var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.94 8.23C19.57 5.76 17.32 4 14.82 4H11.95C11.43 4 11 4.43 11 4.95C11 5.47 11.43 5.9 11.95 5.9H14.85C16.45 5.9 17.89 7.04 18.07 8.63C18.24 10.06 17.43 11.32 16.22 11.85L17.62 13.25C19.25 12.23 20.26 10.34 19.94 8.23V8.23ZM2.12 0.56C1.73 0.17 1.1 0.17 0.709996 0.56C0.319996 0.95 0.319996 1.58 0.709996 1.97L3.11 4.37C1.17 5.17 -0.160004 7.14 0.0199964 9.41C0.229996 12.05 2.59 14 5.23 14H8.05C8.57 14 9 13.57 9 13.05C9 12.53 8.57 12.1 8.05 12.1H5.16C3.53 12.1 2.06 10.91 1.91 9.28C1.76 7.56 3.02 6.11 4.66 5.93L6.76 8.03C6.33 8.12 6 8.49 6 8.95V9.05C6 9.57 6.43 10 6.95 10H8.73L11 12.27V14H12.73L16.03 17.3C16.42 17.69 17.05 17.69 17.44 17.3C17.83 16.91 17.83 16.28 17.44 15.89L2.12 0.56ZM14 8.95C14 8.43 13.57 8 13.05 8H12.39L13.88 9.49C13.95 9.36 14 9.21 14 9.05V8.95V8.95Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectIcon);
export default __webpack_public_path__ + "static/media/disconnect-icon.2267d4c9352eed0355502334115b97bf.svg";
export { ForwardRef as ReactComponent };